import { useSelectOption } from "App/hooks"
import React from "react"
import {
  FormTipeKartuNoKartuDanNoTransfer,
  preLoadDataPegawai,
  preLoadDataPotongan,
} from "../../InputTagihan/ui/TabBayar/helpers"
import { Grid } from "@material-ui/core"
import {
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
  InputReactDatepicker,
  InputFieldAsyncOption,
  InputTextLabel,
} from "App/Component/ui"
import { formatRupiah } from "App/utils/helpers"
import { TYPE_INSTANCE3, valueTipePembayaran } from "App/constants"

const FormTabSaldo = ({
  handleSubmit,
  handleChange,
  disabled,
  formData,
  setFormData,
  isSaldo = false,
  isTagihan = false,
}) => {
  const kasBank = useSelectOption(
    true,
    isSaldo
      ? "/kas/kas/list-pemb-saldo"
      : isTagihan
      ? "/kas/kas/list-pemb-tagihan"
      : "/kas/kas/list",
    TYPE_INSTANCE3,
    "id",
    "nama",
  )

  return (
    <form action="POST" onSubmit={(e) => handleSubmit(e)}>
      <InputTextMaster
        type="hidden"
        name="id"
        id="id"
        readOnly={true}
        value={formData.id}
      />
      <Grid container spacing={2}>
        <Grid item sm={formData.tipe_pembayaran_id.toString() === "2" ? 6 : 12}>
          <Grid container spacing={1}>
            <Grid item sm={12}>
              <InputReactDatepicker
                selected={formData.date}
                label="TANGGAL"
                handleChangeToday={(e) =>
                  setFormData({
                    ...formData,
                    date: e,
                  })
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    date: e,
                  })
                }
              />
            </Grid>
            <Grid item sm={12}>
              <InputOptionMaster
                name="tipe_pembayaran_id"
                label="TIPE PEMBAYARAN"
                id="tipe_pembayaran_id"
                withSearch={false}
                value={formData.tipe_pembayaran_id}
                onChange={handleChange("tipe_pembayaran_id")}
                data={valueTipePembayaran}
              />
            </Grid>

            {formData.tipe_pembayaran_id?.toString() === "6" ? (
              <Grid
                item
                sm={12}
                style={{
                  backgroundColor: "#F5F5F5",
                  padding: "10px",
                  border: "1px solid #eaeaea",
                  borderRadius: "3px",
                  margin: "8px 4px",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <InputTextLabel label={"Pegawai"} id={"pegawai"} />
                    <InputFieldAsyncOption
                      name="Pegawai"
                      label="Pegawai"
                      defaultLabel="/ Cari Pegawai..."
                      id="nik_pegawai"
                      needParse={false}
                      withSearch={true}
                      data={[]}
                      loadOptions={preLoadDataPegawai}
                      value={formData?.nik_pegawai?.value}
                      labelValue={formData?.nik_pegawai?.label}
                      defaultData={formData?.nik_pegawai?.label}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          nik_pegawai: e ?? null,
                        })
                      }}
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <InputTextLabel label={"Jenis Potongan"} id={"potongan"} />
                    <InputFieldAsyncOption
                      name="Potongan"
                      label="Potongan"
                      defaultLabel="/ Cari Jenis Potongan..."
                      id="potongan"
                      needParse={false}
                      withSearch={true}
                      data={[]}
                      loadOptions={preLoadDataPotongan}
                      value={formData?.kode_potongan?.value}
                      labelValue={formData?.kode_potongan?.label}
                      defaultData={formData?.kode_potongan?.label}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          kode_potongan: e ?? null,
                        })
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <></>
            )}
            <Grid item sm={12}>
              <InputOptionMaster
                name="kas_id"
                label="KAS"
                id="kas_id"
                data={kasBank}
                withSearch={true}
                value={formData.kas_id}
                labelValue={formData.kas_name}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    kas_id: e?.value,
                    kas_name: e?.label,
                  })
                }}
              />
            </Grid>
            <Grid item sm={12}>
              <InputTextMaster
                name="amount2"
                label="PEMBAYARAN"
                id="amount2"
                value={formData.amount2}
                autoFocus={true}
                onInput={(e) => {
                  let val = e.target.value
                  setFormData({
                    ...formData,
                    amount2: formatRupiah(val),
                  })
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        {formData.tipe_pembayaran_id.toString() === "2" && (
          <Grid item sm={6}>
            <Grid container spacing={1}>
              <FormTipeKartuNoKartuDanNoTransfer
                formData={formData}
                handleChange={handleChange}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <MasterButton
          className={"mt-1"}
          type="submit"
          color={disabled.color}
          name={disabled.label}
          disabled={disabled.state}
          size="md"
        />
      </Grid>
    </form>
  )
}
export default FormTabSaldo
